import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';

import allOrdersReduser from './slices/allOrdersSlice';
import asnReducer from './slices/asnSlice';
import authReducer from './slices/authSlice';
import deliveryFormReducer from './slices/deliveryFormSlice';
import logoutReducer from './slices/logoutSlice';
import ordersReducer from './slices/ordersSlice';
import paymentHistoryCardsReducer from './slices/paymentHistoryCardSlice';
import paymentsSliceReducer from './slices/paymentsSlice';
import popupReducer from './slices/popupSlice';
import refundFormReducer from './slices/refundFormSlice';
import registrationReducer from './slices/registrationSlice';
import stocksReducer from './slices/stocksSlice';
import updateOrderReduser from './slices/updateOrderSlice';
import userReducer from './slices/userSlice';

const store = configureStore({
  reducer: {
    asns: asnReducer,
    auth: authReducer,
    deliveryForm: deliveryFormReducer,
    orders: ordersReducer,
    refundForm: refundFormReducer,
    stocks: stocksReducer,
    paymentHistoryCards: paymentHistoryCardsReducer,
    popup: popupReducer,
    user: userReducer,
    logout: logoutReducer,
    registration: registrationReducer,
    allOrders: allOrdersReduser,
    updateOrder: updateOrderReduser,
    cards: paymentsSliceReducer,
  },
});

export const useAppDispatch = () => useDispatch();
export const useAppSelector = useSelector;

export default store;
